module.exports = __webpack_public_path__ + "img/login_title.42888c69.png";